<div class="grid" style="margin-top: 8px;">
  <div class="col-12 lg:col-12">
    <div class="card lg:h-28rem">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.apiInfo' | transloco}}</h4></div>
      <hr>
      <table *ngIf="!loadingApiKey" class="details-table striped-table">
        <tr>
          <td class="p-3 bold">{{'attribute.apikey' | transloco}}</td>
          <td>
            <app-clipboard-label
              *ngIf="apiKey"
              [value]="apiKey"
              [copiedValue]="apiKey"
              style="word-break: break-all;"
            ></app-clipboard-label>
            <label *ngIf="!apiKey">{{'empty.apikey' | transloco}}</label>
          </td>
        </tr>
        <tr>
          <td></td>
          <td class="p-3 bold">
            <button
              *ngIf="'ROLE_ADMIN' | userHasRole"
              [label]="'common.newapikey' | transloco"
              (click)="apiKey ? confirmAndNewApiKey() : newApiKey()"
              pButton
              pRipple
              class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
              icon="pi pi-plus"
            ></button>
          </td></tr>
      </table>
      <app-table-skeleton *ngIf="loadingApiKey" [rows]="7"></app-table-skeleton>
    </div>
  </div>
</div>
